enum TaskType {
  Root = 'ROOT',
  RefreshTile = 'REFRESH_TILE',
}

export default TaskType
